import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/terms" className="footer-link">Terms & Conditions</Link>
          <span className="footer-divider">•</span>
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} culr.app. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;